<template>
  <article id="single-page" class="container" v-if="loaded">
    <h1>{{page.title.rendered}}</h1>
    <div v-html="page.excerpt.rendered"></div>
    <div class="how">
      <figure>
        <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
        <figcaption>
          Creatie
        </figcaption>
      </figure>
      <figure>
        <img alt="Uitvoering" src="../assets/uitvoering.svg">
        <figcaption>
          Uitvoering
        </figcaption>
      </figure>
      <figure>
        <img alt="Productie" src="../assets/productie.svg">
        <figcaption>
          Productie
        </figcaption>
      </figure>
    </div>
  </article>
</template>

<script>
import { settings } from '../variables.js'
import Lottie from 'vue-lottie'
import * as animationCreatie from '../assets/animations/creatie.json'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  name: 'page',
  components: {
    'lottie': Lottie
  },
  data () {
    return {
      page: {},
      defaultOptions: { animationData: animationCreatie.default, loop: false, autoPlay: true },
      animationText: 'This is my text'
    }
  },
  created: function () {
    this.getData(this.$route.params.pageSlug)
  },
  watch: {
    '$route.params.pageSlug': function (pageSlug) {
      this.getData(pageSlug)
    }
  },
  methods: {
    getData: function (pageSlug) {
      this.axios
        .get(settings.jsonUrl + 'wp/v2/pages?slug=hoe-wij-werken')
        .then(response => (this.page = response.data[0]))
        .then(function (result) {
          NProgress.done()
        })
        .catch(error => console.log(error))
    },
    handleAnimation: function (anim) {
      this.anim = anim
      // let c = document.getElementById('changetext')
      // let t = c.querySelector('tspan')
      // let t = c.querySelectorAll('text')[0]
      // t.textContent = this.animationText
    }
  },
  computed: {
    loaded () {
      return !(Object.entries(this.page).length === 0 && this.page.constructor === Object)
    },
    members () {
      return this.$store.state.teamModule.members
    }
  }
}
</script>

<style lang="scss">
  .how {
    display: flex;
    align-items: flex-start;

    figure {
      flex: 1;
      margin: 1em 1em;

      figcaption {
        margin-top: 1em;
        font-size: 1.15em;
      }
    }
  }
</style>
